<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="card-title ">List Laporan</h4>
                    <p class="card-category">Berikut ini daftar Laporan dari pelanggan</p>
                  </div>
                </div>
              </div>
              <div class="card-body" >
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Sistem</th>
                    <th>Aksi</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.List" >
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</br> {{ u.wa }}</td>
                        <td>
                          <span v-if="u.status == null">Direct ke WA teknisi</span> 
                          <span v-else>Aplikasi</span>
                        </td>
                        <td>{{ u.jam }}
                            </br>
                            {{ tglIndo(u.tanggal) }}
                        </td>
                        <td>
                          <router-link :to="{ name: 'detail-laporan', params: u }" class="btn btn-sm btn-info" @click="mikrotik.data.idHapus = u.id"><i class="material-icons">remove_red_eye</i></router-link>
                        </td>
                      </tr>
                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
      </div>

			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="data.modalHapus">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Hapus Mikrotik</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalHapus = false">
              <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-md-12">
                <p>Hapus Mikrotik?</p>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="data.modalHapus = false,mikrotik.hapus()">Hapus</button>
              <button type="button" class="btn btn-secondary" @click="data.modalHapus = false">Tutup</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
  name: 'Beranda',
  components: { 
    'Loading': Loading
  }, 
  setup() {
    const data = reactive({
      modalDetail: false,
      modalHapus: false

      /* modal edit tarif */
    })

    const theGet = {
      data: reactive({
        List: [],
        Listx: []
      }),
      datae() {
        //console.log(sessionStorage.getItem('admin'));
			  // for filter

        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken')
        }
			
			  var apiUrl = inter.Laporan();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
              this.data.List = x.data;
          } else {
              //alert(x.pesan);
          }
        })
      }
    }

    return {
      data, 
      theGet
    }
  },
  mounted () {
    document.title = "Daftar Laporan";

    this.theGet.datae();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/laporan/main.vue